import {
  type PublicArubaNewCentralApiSettings,
  type PublicAwsApiSettings,
  type PublicAzureApiSettings,
  type PublicCheckPointApiSettings,
  type PublicCiscoApicApiSettings,
  type PublicCiscoFmcApiSettings,
  type PublicF5osAApiSettings,
  type PublicF5osCApiSettings,
  type PublicForcePointApiSettings,
  type PublicGcpApiSettings,
  type PublicJuniperMistApiSettings,
  type PublicMerakiApiSettings,
  type PublicNsxTApiSettings,
  type PublicPrismaApiSettings,
  type PublicRuckusVszApiSettings,
  type PublicSilverPeakApiSettings,
  type PublicVeloCloudApiSettings,
  type PublicVersaApiSettings,
  type PublicViptelaApiSettings,
  type RateLimiterSettings,
  makeTypeGuardByProperty,
  makeTypeGuardByPropertyValue,
  settingTypes,
} from '@ipfabric/utils';
import type { TemporaryClientProperties, Vendor } from '../vendorTypes';

export function isRateLimiterSettings(
  values: unknown,
): values is RateLimiterSettings {
  return (
    typeof values === 'object' &&
    values !== null &&
    'refillRateIntervalMs' in values &&
    'refillRate' in values &&
    'maxCapacity' in values
  );
}
export const isGcpVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicGcpApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.gcp);

export const isForcePointVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicForcePointApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.forcepoint);

export const isPrismaVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicPrismaApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.prisma);

export const isAwsVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicAwsApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.aws);

export const isAzureVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicAzureApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.azure);

export const isCheckPointVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicCheckPointApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.checkpoint);

export const isCiscoFmcVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicCiscoFmcApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.ciscofmc);

export const isCiscoApicVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicCiscoApicApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.ciscoapic);

export const isF5osAVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicF5osAApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.f5osa);

export const isF5osCVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicF5osCApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.f5osc);

export const isJuniperMistVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicJuniperMistApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.junipermist);

export const isNsxTVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicNsxTApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.nsxT);

export const isRuckusVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicRuckusVszApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.ruckusvsz);

export const isSilverPeakVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicSilverPeakApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.silverpeak);

export const isVeloCloudVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicVeloCloudApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.velocloud);

export const isVersaVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicVersaApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.versa);

export const isArubaNewCentralVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicArubaNewCentralApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.arubaNewCentral);

export const isViptelaVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicViptelaApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.viptela);

export const isMerakiVendor = makeTypeGuardByPropertyValue<
  Vendor,
  PublicMerakiApiSettings & TemporaryClientProperties
>()('type', settingTypes.vendorApiNames.meraki);

export const isVendorUpdate = makeTypeGuardByProperty<
  Vendor,
  Vendor & settingTypes.VendorApiExistingSettings
>('id');
